export default {"src":"/_next/static/media/carrer-remove.bab7bcbc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};